import { styled as muiStyled } from '@mui/material'

export const PrintableNextVisitColumnLeftSide = muiStyled('div')(
  ({ theme }) => `
width: 20%;
flex-shrink: 0;
@media(min-width: ${theme.breakpoints.values.md}px) {
    width: 50%;
}
@media print {
    width: 50%;   
}
`,
)
